
import { useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  IconButton,
  InputAdornment,
  Typography,
  Divider,
  Alert,
  OutlinedInput,
  InputLabel,
  FormControl,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { emailRegex, strongPasswordRegex } from "../../utils/authUtils";
import  Google from '../../assets/images/Google.png';

export default function LoginForm({
  loginData,
  setLoginData,
  emailValid,
  setEmailvalid,
  // passwordValid,
  setPasswordValid,
  showPassword,
  setShowPassword,
  handleLogin,
  loginFailedError,
  loading,
  handlePasswordReset,
  handleGoogleLogin,
}) {

  /* for email field validation */
  useEffect(() => {
    if (loginData.email.trim() === "") {
      setEmailvalid((prev) => ({ ...prev, login: true }));
    } else if (!emailRegex.test(loginData.email)) {
      setEmailvalid((prev) => ({ ...prev, login: false }));
    } else {
      setEmailvalid((prev) => ({ ...prev, login: true }));
    }
  }, [loginData.email, setEmailvalid]);

  /* for password field validation */
  useEffect(() => {
    if (loginData.password.trim() === "") {
      setPasswordValid((prev) => ({ ...prev, login: true }));
    } else if (!strongPasswordRegex.test(loginData.password)) {
      setPasswordValid((prev) => ({ ...prev, login: false }));
    } else {
      setPasswordValid((prev) => ({ ...prev, login: true }));
    }
  }, [loginData.password, setPasswordValid]);

  return (
    <Box component="form" sx={{ mt: 2 }}>
      {loginFailedError && <Alert severity="error">{loginFailedError}</Alert>}
      <TextField
        label="Email Address"
        fullWidth
        margin="normal"
        type="email"
        placeholder="Enter your email"
        value={loginData.email}
        slotProps={{ htmlInput: { maxLength: 100 } }}
        onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
        error={!emailValid.login}
        helperText={!emailValid.login && "Enter a valid email address"}
      />
      <FormControl sx={{ my: 2 }} variant="outlined" fullWidth>
      <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
      <OutlinedInput
        id="outlined-adornment-password"
        label="Password"
        margin="normal"
        type={showPassword ? "text" : "password"}
        placeholder="Enter your password"
        value={loginData.password}
        onChange={(e) =>
          setLoginData({ ...loginData, password: e.target.value })
        }
        // error={!passwordValid.login}
        // helperText={
        //   !passwordValid.login &&
        //   "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character."
        // }

          endAdornment= {
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        slotProps={{ htmlInput: { maxLength: 50} }}
      />
      </FormControl>
      
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
        <Typography variant="body2" color="text.secondary">Secured with industry-standard encryption</Typography>
        <Button
          size="small"
          onClick={handlePasswordReset}
          sx={{ textTransform: "none", fontSize: "medium" }}
        >
          Forgot Password?
        </Button>
      </Box>

      <Button
        fullWidth
        variant="contained"
        onClick={handleLogin}
        loading={loading}
        loadingPosition="end"
        disabled={
          !emailValid.login || !loginData.email || !loginData.password || loading
        }
        sx={{ mt: 2, py: 1, fontSize: "medium", textTransform: "none" }}
      >
        Log In
      </Button>

      <Divider sx={{ my: 3 }}>
        <Typography sx={{ color: "gray" }}>or continue with</Typography>
      </Divider>

      {/* Google login button */}
      <Button
        fullWidth
        variant="outlined"
        startIcon={
          <img
            src={Google}
            alt="Google"
            style={{ width: 20, height: 20 }}
          />
        }
        onClick={handleGoogleLogin}
        sx={{ textTransform: "none", py: 1 }}
      >
        Log In with Google
      </Button>
    </Box>
  );
}
